import { faUserCircle } from "@fortawesome/fontawesome-free-solid";
import { faBars, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  Button,
  Col,
  Container,
  Dropdown, Form,
  Jumbotron,
  Navbar,
  Row,
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { slide as Menu } from "react-burger-menu";
import { withTranslation } from "react-i18next";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import LanguageSelection from "../../components/languageSelection/LanguageSelection";
import Classes from "../../routes/classes/Classes";
import Groups from "../../routes/groups/Groups";
import Dashboard from "../dashboard/Dashboard";
import ExaminationAccess from "../examinationAccess/ExaminationAccess";
import Examinations from "../examinations/Examinations";
import InstanceTemplates from "../instanceTemplates/InstanceTemplates";
import ModuleClasses from "../moduleClasses/ModuleClasses";
import NetworkProfiles from "../networkProfiles/NetworkProfiles";
import Scripts from "../scripts/Scripts";
import SingleExamination from "../singleExamination/SingleExamination";
import SingleInstanceTemplate from "../singleInstanceTemplate/SingleInstanceTemplate";
import SingleNetworkProfile from "../singleNetworkProfile/SingleNetworkProfile";
import SingleScript from "../singleScript/SingleScript";
import SingleSoftwareCatalog from "../singleSoftwareCatalog/SingleSoftwareCatalog";
import SoftwareCatalogs from "../softwareCatalogs/SoftwareCatalogs";
import TemplateMarketplace from "../templateMarketplace/TemplateMarketplace";
import Hardware from "../hardware/Hardware";
import HardwareChecker from "../hardwareChecker/HardwareChecker";
import Users from "../users/Users";
import Help from "./help/Help";
import "./MainComponent.css";
import Modules from "../modules/Modules";
import CamplaCoreService from "../../services/CamplaCoreService";
import Login from "../login/Login";

class MainComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isAuthenticated: true,
      authenticatedUser: null,
      apiError: ""
    };

    this.handleLoginUpdate = this.handleLoginUpdate.bind(this);

  }


  async componentDidMount() {
    try {
      CamplaCoreService.login();
      const isAuthenticated = await CamplaCoreService.isAuthenticated();
      if (!isAuthenticated) {
        if (
            typeof window["authenticators"] !== "undefined"
            && Array.isArray(window["authenticators"])
            && window.location.pathname !== "/login") {
          const preferredAuthenticator = window.authenticators.filter(auth => auth.preferred);
          if (preferredAuthenticator.length > 0) {
            window.location.href = preferredAuthenticator[0].loginLink
          }
        }
      }
      const authenticatedUser = CamplaCoreService.getAuthenticatedUser();
      this.setState({
        isAuthenticated: isAuthenticated,
        authenticatedUser,
      });

    }catch (err){
      console.error(err);
    }
  }

  componentWillUnmount() {
    CamplaCoreService.resetEventSource();
  }

  async handleLoginUpdate(){
    const isAuthenticated = await CamplaCoreService.isAuthenticated();
    this.setState({
      isAuthenticated: isAuthenticated,
      authenticatedUser: CamplaCoreService.getAuthenticatedUser(),
    });
  }

  render() {
    const { t } = this.props;

    const navbar =
      this.state.isAuthenticated &&
      this.state.authenticatedUser &&
      this.state.authenticatedUser.role !== 2 ? (
        this.state.authenticatedUser.role === 1 ? (
          <div>
            <Menu
              isOpen={this.state.isOpen}
              onClose={() => this.setState({ isOpen: false })}
              customBurgerIcon={false}
            >
              <a id="home" className="menu-item" href="/">
                {t("MainComponent.Sidebar.Dashboard")}
              </a>
              <a id="classes" className="menu-item" href="/classes">
                {t("MainComponent.Sidebar.Classes")}
              </a>
              <a className="menu-item--small" href="/modules">
                {t("MainComponent.Sidebar.Modules")}
              </a>
              <a id="moduleClasses" className="menu-item" href="/moduleClasses">
                {t("MainComponent.Sidebar.ModuleClasses")}
              </a>
              <a className="menu-item" href="/examinations">
                {t("MainComponent.Sidebar.Examinations")}
              </a>
              <a className="menu-item--small" href="/instanceTemplates">
                {t("MainComponent.Sidebar.InstanceTemplates")}
              </a>
              <a className="menu-item--small" href="/networkProfiles">
                {t("MainComponent.Sidebar.NetworkProfiles")}
              </a>
              <a className="menu-item--small" href="/softwareCatalogs">
                {t("MainComponent.Sidebar.SoftwareCatalogs")}
              </a>
              <a className="menu-item--small" href="/scripts">
                {t("MainComponent.Sidebar.Scripts")}
              </a>
              <a className="menu-item--small" href="/hardware">
                {t("MainComponent.Sidebar.Hardware")}
              </a>
              <a className="menu-item--small" href="/users">
                {t("MainComponent.Sidebar.Users")}
              </a>
              <a className="menu-item--small" href="/groups">
                {t("MainComponent.Sidebar.Groups")}
              </a>
              <a className="menu-item--small" href="/examinationAccess">
                {t("MainComponent.Sidebar.ExaminationAccess")}
              </a>
            </Menu>
          </div>
        ) : (
          <div>
            <Menu
              isOpen={this.state.isOpen}
              onClose={() => this.setState({ isOpen: false })}
              customBurgerIcon={false}
            >
              <a id="home" className="menu-item" href="/">
                {t("MainComponent.Sidebar.Dashboard")}
              </a>
              <a id="classes" className="menu-item" href="/classes">
                {t("MainComponent.Sidebar.Classes")}
              </a>
              <a id="moduleClasses" className="menu-item" href="/moduleClasses">
                {t("MainComponent.Sidebar.ModuleClasses")}
              </a>
              <a className="menu-item--small" href="/templateMarketplace">
                {t("MainComponent.Sidebar.InstanceTemplates")}
              </a>
              <a className="menu-item" href="/examinations">
                {t("MainComponent.Sidebar.Examinations")}
              </a>
              <a className="menu-item--small" href="/examinationAccess">
                {t("MainComponent.Sidebar.ExaminationAccess")}
              </a>
            </Menu>
          </div>
        )
      ) : (
        ""
      );

    const burgerMenu =
      this.state.isAuthenticated &&
      this.state.authenticatedUser &&
      this.state.authenticatedUser.role !== 2 ? (
        <Button
          className="menuButton"
          onClick={() => this.setState({ isOpen: true })}
          variant="light"
        >
          {" "}
          <FontAwesomeIcon icon={faBars} size="2x" />
        </Button>
      ) : (
        ""
      );

    let main = (
      <div>
        <main>
          <Switch>
            <Route path="/help">
              <Help />
            </Route>
            <Route path="/">
              <Login onLoginUpdate={this.handleLoginUpdate} />
            </Route>
          </Switch>
        </main>
      </div>
    );
    if (this.state.isAuthenticated && this.state.authenticatedUser) {
      switch (this.state.authenticatedUser.role) {
        case 0:
          main = (
            <main>
              <Switch>
                <Route path="/classes">
                  <Classes />
                </Route>
                <Route path="/moduleClasses">
                  <ModuleClasses />
                </Route>
                <Route path="/templateMarketplace">
                  <TemplateMarketplace />
                </Route>
                <Route path="/examinationAccess">
                  <ExaminationAccess />
                </Route>
                <Route path="/examinations/:id" component={SingleExamination} />
                <Route path="/examinations">
                  <Examinations />
                </Route>
                <Route path="/hardwarecheck">
                  <HardwareChecker />
                </Route>
                <Route path="/help">
                  <Help />
                </Route>
                <Route path="/">
                  {" "}
                  {/*Has to be the last route definition! */}
                  <Dashboard />
                </Route>
              </Switch>
            </main>
          );
          break;
        case 1:
          main = (
            <main>
              <Switch>
                <Route path="/classes">
                  <Classes />
                </Route>
                <Route path="/groups">
                  <Groups />
                </Route>
                <Route path="/modules">
                  <Modules />
                </Route>
                <Route path="/moduleClasses">
                  <ModuleClasses />
                </Route>
                <Route path="/templateMarketplace">
                  <TemplateMarketplace />
                </Route>
                <Route path="/examinationAccess">
                  <ExaminationAccess />
                </Route>
                <Route path="/examinations/:id" component={SingleExamination} />
                <Route path="/examinations">
                  <Examinations />
                </Route>
                <Route
                  path="/instanceTemplates/:id"
                  component={SingleInstanceTemplate}
                />
                <Route path="/instanceTemplates">
                  <InstanceTemplates />
                </Route>
                <Route
                  path="/networkProfiles/:id"
                  component={SingleNetworkProfile}
                />
                <Route path="/networkProfiles">
                  <NetworkProfiles />
                </Route>
                <Route
                  path="/softwareCatalogs/:id"
                  component={SingleSoftwareCatalog}
                />
                <Route path="/softwareCatalogs">
                  <SoftwareCatalogs />
                </Route>
                <Route path="/scripts/:id" component={SingleScript} />
                <Route path="/scripts">
                  <Scripts />
                </Route>
                <Route path="/users">
                  <Users />
                </Route>
                <Route path="/hardware">
                  <Hardware />
                </Route>
                <Route path="/hardwarecheck">
                  <HardwareChecker />
                </Route>
                <Route path="/help">
                  <Help />
                </Route>
                <Route path="/">
                  {" "}
                  {/*Has to be the last route definition! */}
                  <Dashboard />
                </Route>
              </Switch>
            </main>
          );
          break;
        default:
          main = (
            <main>
              <Switch>
                <Route path="/help">
                  <Help />
                </Route>
                <Route path="/hardwarecheck">
                  <HardwareChecker />
                </Route>
                <Route path="/">
                  <ExaminationAccess />
                </Route>
              </Switch>
            </main>
          );
          break;
      }
    } else if (this.state.isAuthenticated && !this.state.authenticatedUser) {
      main = <div />;
    }
    return (
      <Router>
        <div>
          {navbar}
          <Navbar expanded="false" bg="light" variant="light" id="mainNavBar">
            {burgerMenu}
            <div className="mx-auto order-0">
              {this.state.isAuthenticated ? (<img
                  alt="Campla Logo"
                  src="/images/logo/Logo-trans-128x128.png"
                  height="50px"
              />) : ""}
            </div>
            <LanguageSelection />
            <Dropdown
              disabled={false}
              onClick={(event) => event.stopPropagation()}
              id="dropdown-basic-button"
              className="ml-2 btn-green"
              alignRight
            >
              <Dropdown.Toggle id="user-dropdown">
                <FontAwesomeIcon
                  icon={
                    this.state.isAuthenticated ? faUserCircle : faQuestionCircle
                  }
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/help">
                  {t("MainComponent.Help")}
                </Dropdown.Item>
                {this.state.isAuthenticated ? (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={() => {
                        this.setState({
                          isOpen: false,
                          isAuthenticated: false,
                          authenticatedUser: null,
                        });
                        CamplaCoreService.logout();
                      }}
                    >
                      {t("MainComponent.Logout")}
                    </Dropdown.Item>
                  </>
                ) : (
                  <Dropdown.Item as={Link} to="/">
                    {t("MainComponent.Login")}
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Navbar>
          {main}
        </div>
      </Router>
    );
  }
}

export default withTranslation()(MainComponent);
